import { translateClassName } from "../../../../utils/classroomUtils";
import { getChildKey } from "./childUtils";

export const normalizeClassrooms = (value) => {
  if (!value) return [];
  return Array.isArray(value) ? value : [value];
};

export const getClassroomName = (classroom) => {
  const nested = classroom?.classroom || {};
  return (
    classroom?.className ||
    classroom?.classroomName ||
    classroom?.name ||
    classroom?.label ||
    nested?.className ||
    nested?.classroomName ||
    nested?.name ||
    nested?.label ||
    ""
  );
};

export const firstNonEmpty = (...values) =>
  values.find((value) => value !== null && value !== undefined && String(value).trim()) || "";

const buildAddress = (...sources) => {
  const source = sources.find(Boolean) || {};
  const direct = firstNonEmpty(
    source?.teacherAddress,
    source?.address,
    source?.streetAddress,
    source?.formattedAddress,
    source?.fullAddress,
  );

  if (direct) return direct;

  const street = firstNonEmpty(source?.street, source?.streetName);
  const houseNumber = firstNonEmpty(source?.houseNumber, source?.number);
  const houseNumberAddition = firstNonEmpty(source?.houseNumberAddition, source?.addition);
  const postalCode = firstNonEmpty(source?.postalCode, source?.zipCode, source?.zipcode);
  const city = firstNonEmpty(source?.city, source?.place);

  const line1 = [street, houseNumber, houseNumberAddition].filter(Boolean).join(" ").trim();
  const line2 = [postalCode, city].filter(Boolean).join(" ").trim();

  return [line1, line2].filter(Boolean).join("\n");
};

export const getTeacherName = (classroom) => {
  const nested = classroom?.classroom || {};
  const teacher =
    classroom?.teacher ||
    classroom?.primaryTeacher ||
    nested?.teacher ||
    nested?.primaryTeacher ||
    (Array.isArray(classroom?.teachers) ? classroom.teachers[0] : null) ||
    (Array.isArray(nested?.teachers) ? nested.teachers[0] : null);

  return (
    [classroom?.teacherFirstName, classroom?.teacherLastName].filter(Boolean).join(" ") ||
    [nested?.teacherFirstName, nested?.teacherLastName].filter(Boolean).join(" ") ||
    [teacher?.firstName, teacher?.lastName].filter(Boolean).join(" ") ||
    classroom?.teacherName ||
    classroom?.teacherFullName ||
    nested?.teacherName ||
    nested?.teacherFullName ||
    teacher?.displayName ||
    teacher?.fullName ||
    teacher?.name ||
    ""
  ).trim();
};

export const getClassroomId = (classroom) => {
  const nested = classroom?.classroom || {};
  return firstNonEmpty(
    classroom?.classroomId,
    classroom?.id,
    classroom?.uuid,
    nested?.id,
    nested?.uuid,
    nested?.classroomId,
  );
};

export const getTeacherId = (classroom) => {
  const nested = classroom?.classroom || {};
  const teacher =
    classroom?.teacher ||
    classroom?.primaryTeacher ||
    nested?.teacher ||
    nested?.primaryTeacher ||
    (Array.isArray(classroom?.teachers) ? classroom.teachers[0] : null) ||
    (Array.isArray(nested?.teachers) ? nested.teachers[0] : null) ||
    {};

  return firstNonEmpty(
    classroom?.teacherId,
    classroom?.primaryTeacherId,
    nested?.teacherId,
    nested?.primaryTeacherId,
    teacher?.id,
    teacher?.uuid,
    teacher?.teacherId,
  );
};

export const getTeacherContactInfo = (classroom) => {
  const nested = classroom?.classroom || {};
  const teacher =
    classroom?.teacher ||
    classroom?.primaryTeacher ||
    nested?.teacher ||
    nested?.primaryTeacher ||
    (Array.isArray(classroom?.teachers) ? classroom.teachers[0] : null) ||
    (Array.isArray(nested?.teachers) ? nested.teachers[0] : null) ||
    {};

  return {
    email: firstNonEmpty(
      classroom?.teacherEmail,
      classroom?.teacherMail,
      classroom?.email,
      nested?.teacherEmail,
      nested?.teacherMail,
      nested?.email,
      teacher?.email,
      teacher?.mail,
    ),
    phone: firstNonEmpty(
      classroom?.teacherPhone,
      classroom?.teacherPhoneNumber,
      classroom?.phone,
      classroom?.phoneNumber,
      nested?.teacherPhone,
      nested?.teacherPhoneNumber,
      nested?.phone,
      nested?.phoneNumber,
      teacher?.phone,
      teacher?.phoneNumber,
      teacher?.mobile,
    ),
    address: firstNonEmpty(
      buildAddress(teacher),
      buildAddress(classroom),
      buildAddress(nested),
      buildAddress(teacher?.address),
      buildAddress(classroom?.teacherAddress),
      buildAddress(nested?.teacherAddress),
    ),
    note: firstNonEmpty(
      classroom?.teacherContactInfo,
      classroom?.contactInfo,
      classroom?.teacherNote,
      nested?.teacherContactInfo,
      nested?.contactInfo,
      nested?.teacherNote,
      teacher?.contactInfo,
      teacher?.note,
    ),
  };
};

export const getCurrentClassroom = (child, classroomsByChild = {}) => {
  const key = getChildKey(child);
  const classrooms = normalizeClassrooms(classroomsByChild?.[key]?.data);
  return classrooms.find((item) => item?.current || item?.isCurrent) || classrooms[0] || null;
};

export const getClassroomLabel = (child, classroomsByChild, t) => {
  const currentClassroom = getCurrentClassroom(child, classroomsByChild);
  const rawClassName =
    getClassroomName(currentClassroom) || child?.currentClassName || child?.className || "";

  return (
    translateClassName(rawClassName) ||
    t("parentPortal.not_assigned", { defaultValue: "Not assigned yet" })
  );
};
